'use strict';

var Sugar = require('sugar-core');

Sugar.Number.defineInstance({

  'toNumber': function(n) {
    return n.valueOf();
  }

});

module.exports = Sugar.Number.toNumber;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/number/toNumber.js
// module id = 702
// module chunks = 1